import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import i18n from '../../../../localization/i18n';
import * as rk from '../../../../localization/resourceKeys';
import * as routePaths from '../../../../constants/routePaths';
import { generateButtonClick } from '../../../../utility/Utilities';
import './PaperlessEnrollmentNotification.scss';
import BannerNotification from '../banner-notification/BannerNotification';

const PaperlessEnrollmentNotification = () => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();
  const closeBanner = () => {
    setIsVisible(false);
  };
  return (
    <>
      {isVisible && (
        <BannerNotification
          className='paperless-enrollment-notification-message-center u-mt-none@m u-mt-small'
          data-marketing-theme={2}
          title={i18n.t(rk.PAPERLESS_ENROLLMENT_TITLE)}
          closeAction={closeBanner}
          closeIcon
        >
          <>
            <p className='c-notification__text'>{i18n.t(rk.PAPERLESS_ENROLLMENT_CONTENT).toString()}</p>
            <div className='c-notification__buttons'>
              <Link
                className='c-btn  c-btn--link'
                data-testid='enroll_in_paperless_link'
                state={{ root: location.pathname }}
                to={routePaths.PAPERLESS_NOTIFICATIONS}
                onClick={() => {
                  // send adobe tagging event
                  generateButtonClick(i18n.t(rk.PAPERLESS_ENROLLMENT_LINK));
                }}
              >
                <span className='c-btn__text u-base-link'>{i18n.t(rk.PAPERLESS_ENROLLMENT_LINK).toString()}</span>
              </Link>
            </div>
          </>
        </BannerNotification>
      )}
    </>
  );
};

export default PaperlessEnrollmentNotification;
